import Model from "./Model";

export interface MediumTypology {
  name: string;
  id: string;
  icon: string;
  reach?: string;
  typology?: string;
  unitOfMeasurement: string;
  croppedLogo?: string;
  exportGranularity?: string;
  position: number;
  budgetDescription?: string;
  showInSlides: boolean;
  slideImageUrl?: string;
}

export interface MediumReach {
  name: string;
  id: string;
}

export interface MediumGranularity {
  name: string;
  id: string;
  hide?: boolean;
}

export default class MediumType extends Model {
  static type = "media";
  static unitOfMeasurements: { [key: string]: string } = {
    people: "Persone",
    average_people_per_minute: "Ascoltatori minuto medio",
    average_people_per_day: "Ascoltatori giorno medio",
    average_readers_per_day: "Lettori giorno medio",
    unique_users: "Utenti unici",
    unique_enabled_devices: "Device unici abilitati",
    viewers_per_month: "Spettatori mese",
    population_coverage: "Copertura popolazione",
    people_per_week: "Traffico settimana",
  };

  typology!: string;
  reach!: string;
  budget!: string;
  exportGranularity!: string;
  name!: string;
  unitOfMeasurement!: string;
  croppedLogo!: string;
  position!: number;
  budgetDescription!: string;
  showInSlides = true;
  slideImageUrl!: string;

  static reaches: Array<MediumReach> = [
    { name: "Nazionale", id: "national" },
    { name: "Locale", id: "local" },
  ];

  static typologies = [
    { name: "Tv", id: "tv" },
    { name: "Radio", id: "radio" },
    { name: "Mall", id: "mall" },
    { name: "Poster", id: "poster" },
    { name: "Cinema", id: "movie_theater" },
    { name: "Digitale", id: "digital" },
    { name: "Generico", id: "generic" },
    { name: "Stampa", id: "press" },
  ];

  static granularities: Array<MediumGranularity> = [
    { name: "Regione", id: "region" },
    { name: "Provincia", id: "district" },
    { name: "Comune", id: "town" },
    { name: "CAP", id: "postalCode" },
    { name: "Bacino", id: "area" },
    { name: "Dato nazionale", id: "unbounded", hide: true },
  ];
}
